// Use $ instead of $ without replacing global $
(function ($) {
  if ($('.two-col-grid').length > 0) {
    /* Load more click count. */
    var item_show = 6,
        length = '';

    /* Function to hide and show element on Load */
    function load_OnReady() {
      $('.two-col-grid .grid-wrapper').find('.card-box').each(function () {
        length = $(this).parents('.two-col-grid .grid-wrapper').find('.card-box').length;
        // console.log(length);
        var index = $(this).index();
        if (index >= item_show) {
          $(this).css('display', 'none').removeClass('active-filter');
        }
        else {
          $(this).css('display', 'block').addClass('active-filter');
        }
        if (length <= item_show) {
          $(this).parents('.two-col-grid').find('.load-more').css('display', 'none');
        } else {
          $(this).parents('.two-col-grid').find('.load-more').css('display', 'inline-block');
        }
      });
    }

    /* Function to show element on Load more click */
    function loadMore() {
      var $i = 0;
      item_show=item_show+6;
 
      $('.two-col-grid .grid-wrapper .card-box').each(function () {
        var $dataDisplay = $(this).css('display');
        if ($dataDisplay == 'block') {
          $i++;
        }
      });                
      if ($i < length) {
        for (var $j = $i; $j < ($i + item_show); $j++)  {
          // $('.column-grid .grid-outer .card').eq($j).css({'display': 'block'});
          $('.two-col-grid .grid-wrapper .card-box').css({'display': 'block'});
-          $('.two-col-grid .load-more').css({'display': 'none'});
        }
      } else {
        $('.two-col-grid .load-more').css({'display': 'none'});
      }
      var offset=$('.two-col-grid .grid-wrapper .card-box:eq(6)').offset().top - $('header.fixed-header').height();
      setTimeout(function(){
        $("html, body").animate({ scrollTop: offset }, "slow");
      },100)
      
    }

    var f = 0, f1 = 0;
    $(document).ready(function () {
      limit_lines('body .two-col-grid .grid-wrapper .card-box .card .card-body p', 2);
      if (f == 0) {
        load_OnReady();
        f = 1;
      }
    });

    $(window).resize(function () {
      limit_lines('body .two-col-grid .grid-wrapper .card-box .card .card-body p', 2);
      if (f1 == 0) {
        load_OnReady();
        f1 = 1;
      }
    });

    $(document).on('click', 'body .two-col-grid .load-more', function (e) {
      e.preventDefault();
      loadMore();
      limit_lines('body .two-col-grid .grid-wrapper .card-box .card .card-body p', 2);
    });


    $(document).on('change', '.two-col-grid .wrapper-1 .application-wrapper', function (e) {
      var value = $(this).val();
      var value2 = $('#views-exposed-form-customer-block-1 .form-item-term-node-tid-depth select').val();

      if (value !== value2) {
        $('#views-exposed-form-customer-block-1 .form-item-term-node-tid-depth select').val(value).trigger('change');
        $('#views-exposed-form-customer-block-1 .form-submit').trigger('click');
      }

      setTimeout(function () {
        load_OnReady();
      }, 1800);
    });

    $(document).on('change', '.two-col-grid .wrapper-2 .recent-wrapper', function (e) {
      var value = $(this).val();
      var value2 = $('#views-exposed-form-customer-block-1 .form-item-term-node-tid-depth-1 select').val();

      if (value !== value2) {
        $('#views-exposed-form-customer-block-1 .form-item-term-node-tid-depth-1 select').val(value).trigger('change');
        $('#views-exposed-form-customer-block-1 .form-submit').trigger('click');
      }
      setTimeout(function () {
        load_OnReady();
      }, 2000);
    });
  }
  if ($('.customer-grid').length > 0) {

    $.get('/customer_solution', function (data) {
      $.each(data, function (key, value) {
        var ID = value.tid;
        var text = value.name;
        var out = '<option value="' + ID + '">' + text + '</option>';
        $('.customer-grid .wrapper-1 select').append(out);
      });

      $(".customer-grid .wrapper-1 select").selectBoxIt().data("selectBox-selectBoxIt").refresh();

    });

    $.get('/customer_product', function (data) {
      $.each(data, function (key, value) {
        var ID = value.tid;
        var text = value.name;
        var out = '<option value="' + ID + '">' + text + '</option>';
        $('.customer-grid .wrapper-2 select').append(out);
      });

      $(".customer-grid .wrapper-2 select").selectBoxIt().data("selectBox-selectBoxIt").refresh();

    });

  }

  $(document).ready(function () {
    var two_col_grid = $('.two-col-grid .grid-wrapper .card-box .card .card-img-top img');
    objectFitImages(two_col_grid);
  });

})(jQuery);